import { actionTypes } from '../actions/data';
import { findDistinct } from '../utils/functions.js';

// DEFAULT STATE
export const initData = {
  'subscriptions':[],
  saveInProgress: 0,
  unsubscribedFromAll: false,
  subcriptionsToLock: [],
};

// Function to update a set of subscriptions without mutating the original subscriptions
function updateSubscriptions(subscriptions, subsToUpdate) {

  // Loop over each subscription that needs updating
  // then map it out to find the subscription in the list
  subsToUpdate.forEach( subToUpdate => {

    subscriptions = subscriptions.map((sub) => {
      // See if this item is one of the updated ones
      if ( (subToUpdate.id && sub.id === subToUpdate.id) || (subToUpdate.name === sub.name)) {
        return {
          ...sub,
          ...subToUpdate,
        };
      }
      return sub;
    });

  })

  return subscriptions;
}

// Updatae the category without mutating original objects
function updateCategory(category, subsToUpdate) {
  
  return {
    category: category.category,
    subCategories: category.subCategories ? category.subCategories.map( category => {
      return updateCategory(category, subsToUpdate);
    }) : null,
    subscriptions: category.subscriptions ? updateSubscriptions(category.subscriptions, subsToUpdate) : null,
    subtitle: category.subtitle,
  };

}

// WRITES
const data = (state = {}, action) => {
  switch (action.type) {
    
    case actionTypes.LOAD_SUBSCRIPTIONS:

      const contactData = action.value;

      // Build the hierarchy based on traversing the Categories downwards from 1
      const category1s = findDistinct('category1', contactData.subscriptions);

      // Get the footer from the first subscription that has one
      const subsWithFooter = contactData.subscriptions.filter( sub => sub.footer !== null);
      const footer = subsWithFooter.length > 0 ? subsWithFooter[0].footer : null;

      // Get the disclaimer from the first subscription that has one
      const subsWithDisclaimer = contactData.subscriptions.filter( sub => sub.disclaimer !== null);
      const disclaimer = subsWithDisclaimer.length > 0 ? subsWithDisclaimer[0].disclaimer : null;

      const tabHierarchy = [];
      category1s.forEach( category1 => {
        
        const hierarchy = {
          'category1': category1,
          'category2s': [],
          'category3s': [],
          'categoryHierarchy': [],
        };

        const subsForCat1 = contactData.subscriptions.filter(sub => sub.category1 === category1);

        // Get all the subs that are just Category 1
        const distinctCat1s = subsForCat1.filter(sub => !sub.category2 && !sub.category3);

        hierarchy.category2s = findDistinct('category2', subsForCat1);
        hierarchy.category3s = findDistinct('category3', subsForCat1);

        const fullHierarchy = {
          'category': category1,
          'subscriptions': distinctCat1s.length > 0 ? distinctCat1s : null,
          'subCategories': [],
          'subtitle': null,
        };

        hierarchy.category2s.forEach(category2 => {

          // Get all the subs for this cat1 and this cat2
          const subsForCat2 = subsForCat1.filter(sub => sub.category2 === category2);

          // Get the subs that are only at the Cat2 level and ones at Cat3
          const onlyCat2 = subsForCat2.filter(sub => !sub.category3);
          
          // Set up the hierarchy of this cat2
          const hierarchy = {
            'category': category2,
            'subscriptions': onlyCat2.length > 0 ? onlyCat2 : null,
            'subCategories': null,
            'subtitle': onlyCat2.length > 0 ? onlyCat2[0].category2Subtitle : null,
          };

          // Find the unique Cat3s for this Cat2
          const category3s = findDistinct('category3', subsForCat2);

          // IF there are category 3s for this cat2 then add them
          if(category3s.length > 0){

            hierarchy.subCategories = [];

            // For each cat3 add a subcategory
            category3s.forEach( category3 => {

              // Get the subs that are only at the Cat2 level and ones at Cat3
              const subsForCat3 = subsForCat2.filter(sub => sub.category3 === category3);
              
              if (subsForCat3.length > 0){
                hierarchy.subCategories.push({
                  'category': category3,
                  'subscriptions': subsForCat3,
                  'subCategories': null,
                  'subtitle': null,
                });
              }
              
            });
          }

          fullHierarchy.subCategories.push(hierarchy);

        });

        hierarchy.categoryHierarchy = fullHierarchy;

        // Store this hierarchy for the cat1
        tabHierarchy.push(fullHierarchy);

      });

      return Object.assign({}, state, {
        // subscriptions: subscriptions,
        category1s: category1s,
        tabHierarchy: tabHierarchy,
        selectedCategory1: category1s.length > 0 ? category1s[0] : null,
        // subscriptionObjectDetails: action.value.subscriptionObjectDetails,
        footer: footer,
        disclaimer: disclaimer,
        contactData: contactData,
        investorType: contactData.investorType,
        globalOptOutDate: contactData.globalOptOutDate,
        webModifiedDate: contactData.webModifiedDate,
        country: contactData.country,
        subcriptionsToLock: [],
        saveInProgress: 0,
      });

    case actionTypes.UPDATE_SELECTED_CAT1:

      // new Category1 to show
      return Object.assign({}, state, {
        selectedCategory1: action.value, 
      }); 

    case actionTypes.UPDATE_SUBSCRIPTIONS:
  
      const names = action.value.map(sub => {
          return sub.name;
      });

      // Update the UI with subscription data.
      // If the subscriptions are being saved then lock the checkboxes by passing
      // an array of names
      return Object.assign({}, state, {
        contactData: {
          ...state.contactData,
          subscriptions:  updateSubscriptions(state.contactData.subscriptions, action.value),
        },
        tabHierarchy: state.tabHierarchy.map( category => {
          return updateCategory(category, action.value);
        }),
        subcriptionsToLock: state.subcriptionsToLock.concat(names),
        globalOptOutDate: null,
      });

    case actionTypes.LOAD_FUND_NAMES:

      // Add fundNames and updated subscriptions
      return Object.assign({}, state, {
        fundNames: action.value,
      }); 

    case actionTypes.SAVE_IN_PROGRESS: {

      const latestCount = action.value ? state.saveInProgress + 1 : state.saveInProgress - 1;

      // Add fundNames and updated subscriptions. Increment or decrement the 
      // counter to track how many saves are going on
      return Object.assign({}, state, {
        saveInProgress: latestCount,
        saveFailed: false,
        subcriptionsToLock: latestCount === 0 ? []: state.subcriptionsToLock,
      }); 

    }

    case actionTypes.SAVE_FAILED:

        // Saving failed so show message
        return Object.assign({}, state, {
          saveInProgress: 1,
          saveFailed: true,
          subcriptionsToLock: [],
        }); 
    
    case actionTypes.UNSUBSCRIBED_FROM_ALL:

        // Save unsubscribed from all date
        return Object.assign({}, state, {
          globalOptOutDate: action.value,
        }); 
      
    default:
      return state;
  }
};

export default data;
